<script>
const _serverUrl_ = {
  baseURI: 'http://localhost:28080',
  // orgBaseURI: 'http://localhost:38080/',
  // orgBaseURI: 'http://192.168.1.11:38080/',
  // orgBaseURI:'http://192.168.31.233:38080',
  // orgBaseURI: 'https://pre.borunxinke.com/',
  // orgBaseURI: 'https://pre.borunxinke.com:1443/',
  // orgBaseURI: 'http://192.168.1.29:38080/',
  // orgBaseURI: 'https://25v31357w5.imdo.co/',
   orgBaseURI: 'https://go.borunxinke.com/',

  // orgBaseURI:'https://wx.jlshskj.cn',thermalAccount_query_newApproved.vue
  orgBaseURI2: 'https://wx.jlshskj.cn/pro_1',
  orgBaseURI3: 'https://wx.jlshskj.cn/fr/getWxMiniMerCode2OpenToDB',
  wxAppid: 'wxcbd4d56905d22b55',

  // baseURI:'http://47.110.133.115:28080',
  getWxMiniMerCode2Openid: '/fr/getWxMiniMerCode2Openid',
  postMerCheckLogin2: '/fr/postMerCheckLogin2',

  postMerCheckLogin: '/fr/postMerCheckLogin',
  postQueryValveCurrentDataList: '/fr/postQueryValveCurrentDataList',
  postMerLoginSessionClear: '/fr/postMerLoginSessionClear',
  postQueryPermissionTemplate: '/fr/postQueryPermissionTemplate',
  postModifyPermissionTemplate: '/fr/postModifyPermissionTemplate',
  postModifyPermissionTemplateForId: '/fr/postModifyPermissionTemplateForId',
  postModifyUserAndBtnKey: '/fr/postModifyUserAndBtnKey',
  postQueryUserOrgAndPermissionKey: '/fr/postQueryUserOrgAndPermissionKey',
  postModifyUserOrgAndPermissionKey: '/fr/postModifyUserOrgAndPermissionKey',
  postQueryOrganTemplate: '/fr/postQueryOrganTemplate',
  postManagerOrganTemplate: '/fr/postManagerOrganTemplate',
  postChangeMerPasswd2: '/fr/postChangeMerPasswd2',

  postQuerySystemConfig: '/fr/postQuerySystemConfig',
  postCreateUserAndPermissionKey: '/fr/postCreateUserAndPermissionKey',
  postCreateUserAndOrgKey: '/fr/postCreateUserAndOrgKey',
  postSaveSystemConfig: '/fr/postSaveSystemConfig',
  postDeleteSystemConfig: '/fr/postDeleteSystemConfig',
  postDeleteUser: '/fr/postDeleteUser',
  postQueryCommunityKV: '/fr/postQueryCommunityKV',
  postQueryBuilderKV: '/fr/postQueryBuilderKV',
  postQueryKeyCommonAccessRedis: '/fr/postQueryKeyCommonAccessRedis',
  postSaveCommonAccessRedis: '/fr/postSaveCommonAccessRedis',

  thermalPowerCompany_query: '/fr/thermalPowerCompany_query',
  thermalPowerCompany_add: '/fr/thermalPowerCompany_add',
  thermalPowerCompany_update: '/fr/thermalPowerCompany_update',
  thermalPowerCompany_delete: '/fr/thermalPowerCompany_delete',
  thermalPowerBranch_query: '/fr/thermalPowerBranch_query',
  thermalPowerBranch_add: '/fr/thermalPowerBranch_add',
  thermalPowerBranch_update: '/fr/thermalPowerBranch_update',
  thermalPowerBranch_delete: '/fr/thermalPowerBranch_delete',
  thermalPowerInstitute_query: '/fr/thermalPowerInstitute_query',
  thermalPowerInstitute_add: '/fr/thermalPowerInstitute_add',
  thermalPowerInstitute_update: '/fr/thermalPowerInstitute_update',
  thermalPowerInstitute_delete: '/fr/thermalPowerInstitute_delete',
  heatExchangeStation_query: '/fr/heatExchangeStation_query',
  heatExchangeStation_add: '/fr/heatExchangeStation_add',
  heatExchangeStation_update: '/fr/heatExchangeStation_update',
  heatExchangeStation_delete: '/fr/heatExchangeStation_delete',
  residentialQuarters_query: '/fr/residentialQuarters_query',
  residentialQuarters_add: '/fr/residentialQuarters_add',
  residentialQuarters_update: '/fr/residentialQuarters_update',
  residentialQuarters_delete: '/fr/residentialQuarters_delete',
  residentialBuildings_query: '/fr/residentialBuildings_query',
  residentialBuildings_add: '/fr/residentialBuildings_add',
  residentialBuildings_update: '/fr/residentialBuildings_update',
  residentialBuildings_delete: '/fr/residentialBuildings_delete',
  residentialHousehold_query: '/fr/residentialHousehold_query',
  residentialHousehold_add: '/fr/residentialHousehold_add',
  residentialHousehold_update: '/fr/residentialHousehold_update',
  residentialHousehold_delete: '/fr/residentialHousehold_delete',
  platformRole_query: '/fr/platformRole_query',
  platformRole_add: '/fr/platformRole_add',
  platformRole_update: '/fr/platformRole_update',
  platformRole_delete: '/fr/platformRole_delete',
  platformAccount_query: '/fr/platformAccount_query',
  platformAccount_add: '/fr/platformAccount_add',
  platformAccount_update: '/fr/platformAccount_update',
  platformAccount_delete: '/fr/platformAccount_delete',
  platformMenu_query: '/fr/platformMenu_query',
  platformMenu_add: '/fr/platformMenu_add',
  platformMenu_update: '/fr/platformMenu_update',
  platformMenu_delete: '/fr/platformMenu_delete',
  thermalRole_query: '/fr/thermalRole_query',
  thermalRole_add: '/fr/thermalRole_add',
  thermalRole_update: '/fr/thermalRole_update',
  thermalRole_delete: '/fr/thermalRole_delete',

  thermalAccount_query: '/fr/thermalAccount_query',
  thermalAccount_add: '/fr/thermalAccount_add',
  thermalAccount_update: '/fr/thermalAccount_update',
  thermalAccount_delete: '/fr/thermalAccount_delete',

  thermalMenu_query: '/fr/thermalMenu_query',
  thermalMenu_add: '/fr/thermalMenu_add',
  thermalMenu_update: '/fr/thermalMenu_update',
  thermalMenu_delete: '/fr/thermalMenu_delete',
  platformRole_queryAll: '/fr/platformRole_queryAll', // 查询全部角色
  platformRole_queryRoleByIds: '/fr/platformRole_queryRoleByIds', // 根据角色ID查询权限
  platformAccount_orgType: '/fr/platformAccount_orgType', // 编辑平台用户查询级别
  resetUserPasswd: '/fr/resetUserPasswd', //
  delUserByArray: '/fr/delUserByArray', //

  residentialQuarters_query_data: '/fr/residentialQuarters_query_data',
  residentialBuildings_query_data: '/fr/residentialBuildings_query_data',

  postChangeMerPasswd2Bank: '/fr/postChangeMerPasswd2Bank',
  postMerCheckLogin2Bank: '/fr/postMerCheckLogin2Bank',

  deviceInfoBank_select: '/fr/Equipment_select', //设备查询
  deviceInfoBank_add_before: '/fr/Equipment_select_address', //设备新增之前接口
  deviceInfoBank_add: '/fr/Equipment_add', //设备新增
  deviceInfoBank_update: '/fr/Equipment_update', //设备修改
  deviceInfoBankFourG_select: '/fr/4G_select', //4G卡查询
  deviceInfoBankFourG_add: '/fr/4G_addAndupdate', //4G卡新增，修改
  bankCompany_query: '/fr/Mechanism_select', //机构查询
  bankCompany_add: '/fr/Mechanism_add', //机构新增
  bankCompany_update: '/fr/Mechanism_update',
  bankCompany_delete: '/fr/Mechanism_delete',
  //银行用户管理
  bankUser_reset: '/fr/bank_user_reset_password',
  bankUser_query: '/fr/thermalAccount_query_new',
  bankUser_add: '/fr/thermalAccount_add_new',
  bankUser_update: '/fr/thermalAccount_update_new',
  bankUser_delete: '/fr/thermalAccount_delete_new',
  deviceInfoBankRegistration_select: '/fr/postManagerQueryRegisterKey',
  deviceInfoBankRegistration_generate: '/fr/postManagerCreateRegisterKey',
  deviceInfoBankRegistration_status: '/fr/postManagerRegisterKeyStatus',
  resetUserPasswd1: '/fr/resetUserPasswd_new', //重置密码
  platformAccount_orgType1: '/fr/platformAccount_orgType_new',

  postCreateUserAndOrgKey_new: '/fr/postCreateUserAndOrgKey',
  platformAccount_orgType_new: '/fr/platformAccount_orgType_new',
  postQueryOrganTemplate_new: '/fr/postQueryOrganTemplate',
  postQueryUserOrgAndPermissionKey_new: '/fr/postQueryUserOrgAndPermissionKey',
  postModifyUserAndBtnKey_new: '/fr/postModifyUserAndBtnKey',
  platformRole_queryRoleByIds_new: '/fr/platformRole_queryRoleByIds',
  platformAccount_query_new: '/fr/platformAccount_query_new',
  platformAccount_delete_new: '/fr/platformAccount_delete_new',
  platformRole_queryAll_new: '/fr/platformRole_queryAll',
  delUserByArray_new: '/fr/delUserByArray_new',
  resetUserPasswd_new: '/fr/resetUserPasswd_new',
  platformAccount_add_new: '/fr/platformAccount_add_new',
  platformAccount_update_new: '/fr/platformAccount_update_new',

  industry_select: '/fr/postManager_Industry_Activity_dictionary_select',
  Bank_activities_add: '/fr/postBankSaveActivity1',
  Bank_coupon_rule_add: '/fr/postBankSaveActivity2',
  Bank_phone_add1: '/fr/Active_mobile_phone_entry',
  Bank_phone_select: '/fr/Active_mobile_phone_entry_select',
  Bank_phone_delete: '/fr/Active_mobile_phone_entry_delete',
  Bank_commercial_add: '/fr/postBankSaveActivity3',
  Bank_invite_merchants_select: '/fr/Optional_merchant_select',
  Bank_industry_select: '/fr/Industry_Activity_dictionary_select',
  Bank_shop_submission: '/fr/Select_merchant_submission',
  Bank_activities_shop_select: '/fr/Merchant_participation_activities',
  Bank_activities_shop_delete: '/fr/Delete_selected_merchant',
  Banking_activity_enquiry_select: '/fr/postBankGetActivityList',
  industry_add: '/fr/Industry_Activity_dictionary_add',
  industry_delete: '/fr/Industry_Activity_dictionary_delete',
  shop_add: '/fr/Merchant_information_bank_add',
  shop_select: '/fr/Merchant_management_review_select',
  shop_status: '/fr/Merchant_management_review_update',
  shop_status1: '/fr/Merchant_management_review_update_new',
  shop_coupon_status: '/fr/postBankModifyMerTicketStatus',
  activeMerchantAudit_select: '/fr/Activity_Registration_Review',
  coupon_select: '/fr/postBankGetActivityTicketList',
  audit_update: '/fr/Activity_Registration_Review_update',
  modify_coupons_number_update: '/fr/postBankModifyTicketNumberCount',
  Store_information_select: '/fr/Store_information_select_new',

  bank_transcoding: '/fr/postManager32CompanyIdCast13CompanyId', //银行行系转码
  bank_configuration: '/fr/postBank13CenterIdWxConfig', //小程序配置，微信支付配置
  generate_qr_code: '/fr/postManagerGetWxCodeUnlimit', //生成二维码
  aliyun_configuration: '/fr/postManagerSmsAliyunConfig', //阿里云提交
  Sweepstakes_Activities_add: '/fr/postManagerCreateLotteryActivityList', //抽奖活动新建活动
  Sweepstakes_Activities_select: '/fr/postManagerQueryLotteryActivityList', //抽奖活动查询
  Offline_activities: '/fr/Offline_activities_update', //抽奖活动删除
  Add_phone_gift: '/fr/add_phone_number_and_lucky_draw', //添加礼品手机号
  select_phone_gift: '/fr/Prize_list_select', //查询礼品手机号
  delete_phone_gift: '/fr/Prize_list_update', //删除礼品手机号
  select_Activities_gift: '/fr/postManagerQueryPriseListForActivity', //查询礼品手机号
  User_prize_select: '/fr/User_prize_extraction_select', //查询一个手机号有几次抽奖机会
  Prize_name_list_select: '/fr/Prize_name_list_select', //查询奖品下拉框列表
  User_prize_add: '/fr/Lucky_draw_add', //新增抽奖次数
  User_prize_update: '/fr/User_prize_extraction_update', //修改抽奖次数中的奖品类型
  Modify_opportunity_echo_select: '/fr/Modify_opportunity_echo_select', //查询本条抽奖次数中的奖品类型
  User_prize_delete: '/fr/User_prize_extraction_delete', //删除抽奖次数
  Number_user_phone: '/fr/postManager_Number_of_Raffles_remaining', //输入手机号查看抽奖机会
  User_lottery: '/fr/postManagerGuestLottery', //用户抽奖
  postManagerLotteryPoolDetailInfo: '/fr/postManagerLotteryPoolDetailInfo', //查询不限制手机号有几次抽奖机会
  postManagerExportPriseListForActivity: '/fr/postManagerExportPriseListForActivity', //导出明细
  postManagerCallBankDevice: '/fr/postManagerCallBankDevice', //设备停用和启用

  mobileBankingMerchant_add: '/fr/postCreateMobileBankMerInfo', //商家与商品管理的商家新增
  mobileBankingMerchant_select: '/fr/postQueryMobileBankMerInfo', //商家与商品管理的商家新增
  commodity_preservation: '/fr/postCURDMobileBankGoodsInfo', //商品保存,修改，删除,查询

  Commodity_merchant_select: '/fr/Commodity_merchant_select', //查询商家
  Merchandise_under_merchant_select: '/fr/Merchandise_under_merchant_select', //查询商品
  postCUDMobileBankGoodsShelvesInfo: '/fr/postCUDMobileBankGoodsShelvesInfo', //提交,查询
  Device_unique_ID_select: '/fr/Device_unique_ID_select', //设备id

  Customer_list_select: '/fr/Customer_list_select', //手机号查询
  Add_phone_number_and_purchase_opportunity: '/fr/add_phone_number_and_purchase_opportunity', //添加手机号
  Number_of_purchases_select: '/fr/Number_of_purchases_select', //查询一个手机号有几次购买机会
  Customer_list_update: '/fr/Customer_list_update', //删除手机号
  Number_of_purchases_update: '/fr/Number_of_purchases_update', //删除次数

  Transaction_record_select: '/fr/Transaction_record_select', //交易记录查询
  postBank13CompanyIdUnionConfig: '/fr/postBank13CompanyIdUnionConfig', //银联配置查询
  postManagerQueryMobileBankGoodsShelvesInfo: '/fr/postManagerQueryMobileBankGoodsShelvesInfo', //设备端商品列表查询
  postGenUnionQrCodeForOuter: '/fr/postGenUnionQrCodeForOuter', //设备端商品生成二维码
  postManagerQueryUnionPayOrderForOuter: '/fr/postManagerQueryUnionPayOrderForOuter', //设备端查询优惠价是否付款
  postManager_Purchase_logic_select: '/fr/postManager_Purchase_logic_select', //设备端特惠价手机号验证
  postManager_Purchase_logic_check_code: '/fr/postManager_Purchase_logic_check_code', //设备端特惠价核销码验证
  Advertisement_add: '/fr/advertisement_add', //设备端图片上传
  Advertisement_select: '/fr/advertisement_select', //设备端图片查询
  Advertisement_delete: '/fr/advertisement_delete', //设备端图片删除

  postManager_Advertisement_select: '/fr/postManager_advertisement_select', //设备端图片查询
  postManagerBankGuestGetActivityList: '/fr/postManagerBankGuestGetActivityList', //设备端业务馆活动查询
  postBankUserAnalysisGetTicketList: '/fr/postBankUserAnalysisGetTicketList', //查询邀请客户及领券情况 - echarts表数据
  Customer_voucher_usage_select: '/fr/Customer_voucher_usage_select', //查询客户用券情况 - echarts表数据
  Special_price_purchase_select: '/fr/Special_price_purchase_select', //查询特惠价客户参与情况 - echarts表数据
  Purchase_at_a_preferential_price_select: '/fr/Purchase_at_a_preferential_price_select', //查询优惠价客户参与情况 - echarts表数据
  Designated_participation_and_winning_select: '/fr/Designated_participation_and_winning_select', //查询参与及中奖人次（指定客户均可参与） - echarts表数据
  postManagersevenDaysParticipants_winners_query: '/fr/postManagersevenDaysParticipants_winners_query', //查询参与及中奖人次（任意客户均可参与） - echarts表数据

  Franchise_scope_select: '/fr/Franchise_scope_select', //加盟商家来源管理列表查询
  Franchise_outlets_add: '/fr/Franchise_outlets_add', //加盟商家来源管理列表选中提交
  Platform_equipment_rate_add: '/fr/Platform_equipment_rate_add', //平台服务费设置提交
  Equipment_platform_service_fee_select: '/fr/Equipment_platform_service_fee_select', //平台服务费设置查询
  Review_of_goods_on_the_shelf_select: '/fr/Review_of_goods_on_the_shelf_select', //商品销售管理的上架审核列表查询

  Review_of_goods_on_the_shelf_update: '/fr/Review_of_goods_on_the_shelf_update', //商品销售管理的上架审核审核提交
  Goods_outside_the_equipment_select: '/fr/Goods_outside_the_equipment_select', //商品销售管理的在售商品（设备外）列表查询

  each_device_rate_query: '/fr/each_device_rate_query', //新增商家按钮，查询各设备及渠道及平台费率
  postBank13CompanyIdAndDeviceUnionConfig: '/fr/postBank13CompanyIdAndDeviceUnionConfig', //渠道及平台费率提交
  cooperative_channel_providers_list_query: '/fr/cooperative_channel_providers_list_query', //渠道商列表查询
  cooperative_channel_providers_insert: '/fr/cooperative_channel_providers_insert', //新增渠道商保存
  channel_each_device_rate_query: '/fr/channel_each_device_rate_query', //查询已合作渠道商中的绑定设备
  channel_each_device_rate_delete: '/fr/channel_each_device_rate_delete', //解绑渠道商中的绑定设备
  channel_each_device_rate_update: '/fr/channel_each_device_rate_update', //提交已合作渠道商中的绑定设备及费率
  merchant_pending_review_query: '/fr/merchant_pending_review_query', //内部商家待审核列表
  other_affiliated_outlets_query: '/fr/other_affiliated_outlets_query', //待审核中的点击审核，弹框查询加盟其他网点列表查询
  other_affiliate_outlets_modify_status_update: '/fr/other_affiliate_outlets_modify_status_update', //待审核中的提交
  merchant_examination_passed_query: '/fr/merchant_examination_passed_query', //审核通过的内部列表查询

  External_upper_and_lower_shelves_of_equipment_update: '/fr/External_upper_and_lower_shelves_of_equipment_update', //商品销售管理的在售商品（设备外）下架
  Goods_in_equipment_select: '/fr/Goods_in_equipment_select', //商品销售管理的在售商品（设备内）列表查询

  Bank_goods_removal_shelf_update: '/fr/Bank_goods_removal_shelf_update', //商品销售管理的在售商品（设备内）银行下架
  Cargo_Lane_outward_to_inward: '/fr/Cargo_Lane_outward_to_inward', //商品销售管理的在售商品（设备外）商品移至设备内
  From_inside_to_outside: '/fr/From_inside_to_outside', //商品销售管理的在售商品（设备内）商品移至设备外
  Set_product_information: '/fr/Set_product_information', //商品销售管理的在售商品（设备内）商品编辑
  Export_merchant_reconciliation_data_select: '/fr/Export_merchant_reconciliation_data_select', //客户权益馆已上线活动导出流水
  Goods_in_equipment_end_select: '/fr/postManagerGoods_in_equipment_end_select', //设备端设备内商品列表查询

  postManagerMerchant_examination_passed_function_open_update: '/fr/postManagerMerchant_examination_passed_function_open_update', //内部商家功能开通
  postManagerMerchant_query: '/fr/postManagerMerchant_query', //根据商家查询关联设备
  internal_merchant_affiliate_network_query: '/fr/internal_merchant_affiliate_network_query', //根据商家查询关联设备

  postGetDeviceGraphInfo: '/fr/postGetDeviceGraphInfo', //根据商家查询关联设备
  postManagerGenUnionQrCodeForOuter: '/fr/postManagerGenUnionQrCodeForOuter', //货道外扫码(银行自己的礼品)
  postManagerGenUnionQrCodeForInnerBank: '/fr/postManagerGenUnionQrCodeForInnerBank', //货道内扫码(银行自己的礼品)
  postManagerGenUnionQrCodeForOuterMer: '/fr/postManagerGenUnionQrCodeForOuterMer', //货道外扫码(商家)
  postManagerGenUnionQrCodeForInnerMer: '/fr/postManagerGenUnionQrCodeForInnerMer', //货道内扫码(商家)
  postPloatFormSaveGraphForDevice: '/fr/postPloatFormSaveGraphForDevice', //平台保存货道图
  Purchase_page_goods_in_the_device_select: '/fr/Purchase_page_goods_in_the_device_select', //商品保存,修改，删除,查询
  Associated_cargo_lane_information_select: '/fr/Associated_cargo_lane_information_select', //查询关联货道的货道信息（货道号和商品）
  Binding_of_goods_and_cargo_lanes_add: '/fr/Binding_of_goods_and_cargo_lanes_add', //查询关联货道的货道信息（货道号和商品）
  Disassociate_cargo_lanes_update: '/fr/Disassociate_cargo_lanes_update', //查询关联货道的货道信息（货道号和商品）

  postManagerGoods_outside_the_equipment_select: '/fr/postManagerGoods_outside_the_equipment_select', //商品销售管理的在售商品（设备外）列表查询
  postManagerPurchase_page_goods_in_the_device_select: '/fr/postManagerPurchase_page_goods_in_the_device_select', //商品保存,修改，删除,查询
  Faulty_track_number_select: '/fr/Faulty_track_number_select', //查询某设备下的所有有故障的货道号
  postBank13CompanyIdAndDeviceUnionConfigExt: '/fr/postBank13CompanyIdAndDeviceUnionConfigExt', //费率修改
  postResetDeviceSoltNumberStatus: '/fr/postResetDeviceSoltNumberStatus', //重置货道状态
  Bank_commodities_on_the_shelves_select: '/fr/Bank_commodities_on_the_shelves_select', //查询商品
  Modify_aisle_inventory_update: '/fr/Modify_aisle_inventory_update', //修改库存

  Goods_outside_the_equipment_end_select: '/fr/postManagerGoods_outside_the_equipment_end_select', //商品销售管理的在售商品（设备外）列表查询
  Equipment_home_page_commodity_display_select: '/fr/postManagerEquipment_home_page_commodity_display_select', //商品销售管理的在售商品（设备外）列表查询
  Reset_equipment_and_rates_update: '/fr/Reset_equipment_and_rates_update', //内部商家保存银行费率

  Service_fee_for_foreign_households_select: '/fr/Service_fee_for_foreign_households_select', //外部商家查询设备

  Service_fee_for_foreign_households_to_be_reviewed_select: '/fr/Service_fee_for_foreign_households_to_be_reviewed_select', //外部商家审核列表查询设备
  Write_off_delivery_flow_select: '/fr/Write_off_delivery_flow_select', //核销流水查询
  Commodity_code_input_write_off: '/fr/Commodity_code_input_write_off', //输码核销
  Verification_write_off_code: '/fr/Verification_write_off_code', //核销码核销

  Histogram_of_number_of_payments_select: '/fr/Histogram_of_number_of_payments_select', //支付笔数
  Payment_amount_histogram_select: '/fr/Payment_amount_histogram_select', //支付金额
  Bar_chart_of_outlet_service_charge: '/fr/Bar_chart_of_outlet_service_charge', //网点收入
  postBankModifyActivityStatusInfo: '/fr/postBankModifyActivityStatusInfo', //核销码核销
  postBankModifyActivityPartInfo: '/fr/postBankModifyActivityPartInfo', //网点收入

  postQueryGetTicketNumberReport: '/fr/postQueryGetTicketNumberReport', //查询 优惠券发放情况（领券数）
  Total_payment_business_Kanban: '/fr/Total_payment_business_Kanban', //查询 查询支付笔数
  postQueryCheckTicketNumberReport: '/fr/postQueryCheckTicketNumberReport', //查询 优惠券发放情况（用券数）
  Payment_amount_Kanban: '/fr/Payment_amount_Kanban', //查询 查询支付金额
  Special_discount_participants: '/fr/Special_discount_participants', //查询 特惠价参与人次信息
  postQueryGetTicketNumberReportForMer: '/fr/postQueryGetTicketNumberReportForMer', //查询 客户领券数
  Preferential_price_participants: '/fr/Preferential_price_participants', //查询 优惠价参与人次信息
  postQueryCheckTicketNumberReportForMer: '/fr/postQueryCheckTicketNumberReportForMer', //客户到店数（以商家为单位）
  postQueryChildernCompanyList: '/fr/postQueryChildernCompanyList', //根据当前层级取下级机构列表

  Service_fee_income_amount: '/fr/Service_fee_income_amount', //服务费收入查询
  postQueryGetDebitOrCreditNumberReport: '/fr/postQueryGetDebitOrCreditNumberReport', //查询 储蓄卡激活人次
  Number_of_participants_in_lottery: '/fr/Number_of_participants_in_lottery', //查询 抽奖活动接口

  postQueryGoodsAttachMerInfo: '/fr/postQueryGoodsAttachMerInfo', //查询 查询商品所隶属的商家
  postQuerySharingTemplate: '/fr/postQuerySharingTemplate', //查询 图片背景库
  postCreateSharingTemplate: '/fr/postCreateSharingTemplate', //新增 图片背景库图片
  postRemoveSharingTemplate: '/fr/postRemoveSharingTemplate', //删除 图片背景库图片
  postQueryActSharingTemplate: '/fr/postQueryActSharingTemplate', //查询 活动选用图片

  Advertisement_bank_list: '/fr/advertisement_bank_list', //查询 上级行系首次查询设备广告列表
  Advertisement_list: '/fr/advertisement_list', //查询 上级行系查询设备广告列表
  Advertisement_create: '/fr/advertisement_create', //添加 上级行系添加设备广告图片
  Advertisement_dev_list: '/fr/advertisement_dev_list', //添加 根据广告id查询关联设备
  advertisement_organization_list: '/fr/advertisement_organization_list', //添加 广告关联小程序网点信息
  QueryChildernCompanyListById: '/fr/QueryChildernCompanyListById', //查询 上级行系查询下级行系列表
  Advertisements_save: '/fr/advertisements_save', //保存 保存广告与设备关联关系
  Advertisements_del: '/fr/advertisements_del', //删除 删除广告与设备关联关系
  Merchant_information_bank_edit: '/fr/Merchant_information_bank_edit', //修改 修改商家信息
  Child_bank_list: '/fr/Child_bank_list', //查询 查询下属机构及网点接口
  Activity_bank_list: '/fr/Activity_bank_list', //查询 查询下属机构及网点接口(初始化查询)
  ticketActualTimeInfo: '/fr/ticketActualTimeInfo', //查询 查询活动实时数据
  exportBaiDataById: '/fr/exportBaiDataById', //导出 导出明细
  Update_bank_list: '/fr/Update_bank_list', // 编辑券池分配数量(分配机制)
  data_act_new_count_participants: '/fr/data_act_new_count_participants', // 查询 数据看板 首绑激活手机银行数量
  data_act_old_count_participants: '/fr/data_act_old_count_participants', // 查询 数据看板 活跃存量手机银行数量
  bmcSave: '/fr/bmcSave', // 保存商家券上限
  getBmcCountByActAndMerId: '/fr/getBmcCountByActAndMerId', // 获取商家优惠券上限数量
  get_Tool_Ticket_List : 'fr/getToolTicketList',  // 获取优惠券列表
  getBankTicketInfoById: 'fr/getBankTicketInfoById', // 根据ttd_id查询信息
  saveBankTicketInfo: 'fr/saveBankTicketInfo',   // 修改规则设置
  getMerTicketList: 'fr/getMerTicketList',  // 设备端商家工具券券池列表
  queryMerStoreTagInfo: 'fr/queryMerStoreTagInfo',  // 获取可用门店

  getBankMerAgreeList:'/fr/getBankMerAgreeList',  // 获取审核列表
  getMerTicketInfoById: 'fr/getMerTicketInfoById',
  isBankMerAgree: 'fr/isBankMerAgree',
  getMerTicketHistoryListByCondition: 'fr/getMerTicketHistoryListByCondition',
  getToolTicketDownList: 'fr/getToolTicketDownList',  // 工具券下拉列表
  getMerTicketInfoListByCondition: 'fr/getMerTicketInfoListByCondition', // 工具券用券明细列表
  exportExportMerTicket: 'fr/exportExportMerTicket', // 明细导出
  getTicketsByCityAndType: 'fr/getTicketsByCityAndType', // 设备端获取商家工具券券池列表
  getContactByBankId: 'fr/getContactByBankId', // 手机银行数据列表
  saveContactInfo: 'fr/saveContactInfo', // 提交手机银行数据
  getOfficialList: 'fr/getOfficialList', // 银行官方公众号数据列表
  getClienteleServicesList: 'fr/getClienteleServicesList', //官方客服数据列表
  saveClienteleServices: 'fr/saveClienteleServices', // 官方客服数据保存
  getStationContactList: 'fr/getStationContactList', // 联系网点数据列表
  delClienteleServices: 'fr/delClienteleServices', // 删除官方客服
  saveOfficial: 'fr/saveOfficial', // 公众号保存
  getClienteleServicesById: 'fr/getClienteleServicesById', // 客服数据编辑
  getOfficialById: 'fr/getOfficialById', // 官方公众号编辑
  delOfficial: 'fr/delOfficial', // 删除公众号
  getStationContactAreas: 'fr/getStationContactAreas', // 联系网点地区下拉框
  getSupermarketsByBankId: 'fr/getSupermarketsByBankId', // 金融超市列表
  saveBankSupermarket: 'fr/saveBankSupermarket', // 金融超市保存
  delBankSupermarket: 'fr/delBankSupermarket', // 金融超市删除
  qrCodeWeChat: 'fr/qrCodeWeChat', // 获取用户端二维码
  getActListInfoByDevice: 'fr/getActListInfoByDevice', // 获取活动列表
  getBaseHmfByBankId: 'fr/getBaseHmfByBankId', // 获取惠民分基础积分配置
  getBusHmfByBankId: 'fr/getBusHmfByBankId', // 查询惠民分业务任务积分设置并初始化
  saveBaseHmf: 'fr/saveBaseHmf', // 保存惠民分基础任务积分设置
  saveBusHmf: 'fr/saveBusHmf', // 保存惠民分业务任务积分设置
  delBusHmfDict: 'fr/delBusHmfDict', // 删除惠民分业务任务积分设置项
  getMerWeekHmfByBankId: 'fr/getMerWeekHmfByBankId', // 商家每周在驿站消耗的分值列表
  saveMerWeekHmf: 'fr/saveMerWeekHmf', // 保存商家应用规则每周用分值
  getDeviceHmfByBankId: 'fr/getDeviceHmfByBankId', // 驿站信息列表接口
  saveDeviceHmf: 'fr/saveDeviceHmf', // 保存驿站信息接口
  getMerHmfListByBankId: 'fr/getMerHmfListByBankId', // 查询商家增分列表
  saveHmfLog: 'fr/saveHmfLog', // 保存商家增分并写入积分日志
  getHmfLogByMerId: 'fr/getHmfLogByMerId', // 查询积分操作日志
  getMerTicketInfoByActId: 'fr/getMerTicketInfoByActId', // 查询积分操作日志
  getRechargeByBankId: 'fr/getRechargeByBankId', // 查询充值管理列表
  getTransactionFlowByBankId: 'fr/getTransactionFlowByBankId', // 查询交易流水
  getWelfareTips: 'fr/getWelfareTips', // 福利锦囊信息获取
  getCooperativeMerchants: 'fr/getCooperativeMerchants', // 合作商家信息获取
  getLayingHotline: 'fr/getLayingHotline', // 布放热线信息获取
  getOperationQualification: 'fr/getOperationQualification', // 运营资质信息获取
  getNewcustomerExclusiveList: 'fr/getNewcustomerExclusiveList', // 新客专享数据列表
  saveJrcsViewCountDay: 'fr/saveJrcsViewCountDay', // 金融超市浏览量日统计表
  saveBankViewCountDay: 'fr/saveBankViewCountDay', // 联系银行浏览量日统计表
  saveTotalViewCountDay: 'fr/saveTotalViewCountDay', // 总浏览量日统计表
  saveWelfareTips: 'fr/saveWelfareTips', // 保存福利锦囊图片
  saveCooperativeMerchants: 'fr/saveCooperativeMerchants', // 保存合作商家图片
  saveLayingHotline: 'fr/saveLayingHotline', // 保存布放热线图片
  saveOperationQualification: 'fr/saveOperationQualification', // 保存运营资质图片
  saveNewcustomerExclusive: 'fr/saveNewcustomerExclusive', // 保存新客专享
  saveRecharge: 'fr/saveRecharge', // 保存充值信息
  delNewcustomerExclusive: 'fr/delNewcustomerExclusive', // 删除新客专享信息
  updateNewcustomerExclusiveStatus: 'fr/updateNewcustomerExclusiveStatus', // 新客专享状态修改
  postBankGetMerList: 'fr/postBankGetMerList', // 新商家审核列表
  Merchant_management_review_update: 'fr/Merchant_management_review_update', // 新商家审核
  getOnlineTerminal: 'fr/getOnlineTerminal', // 在线终端数据统计
  getNewUserStatistics: 'fr/getNewUserStatistics', // 本月新增用户数数据统计
  getNewPayStatistics: 'fr/getNewPayStatistics', // 本月新增交易笔数数据统计
  getPagViewStatistics: 'fr/getPagViewStatistics', // 7日页面浏览量数据统计
  getPayStatistics: 'fr/getPayStatistics', // 7日交易笔数数据统计
  getCollectingCouponsStatistics: 'fr/getCollectingCouponsStatistics', // 7日领用券数数据统计
  getIndicatorByBankId: 'fr/getIndicatorByBankId', // 指标释义列表
  saveBankIndicator: 'fr/saveBankIndicator', // 指标释义保存
  delBankIndicator: 'fr/delBankIndicator', // 指标释义删除
  getDeviceViewCountStatistics: 'fr/getDeviceViewCountStatistics', // 终端页面浏览量
  getDeviceAppPayStatistics: 'fr/getDeviceAppPayStatistics', // 手机银行交易笔数
  getDeviceUserStatistics: 'fr/getDeviceUserStatistics', // 用户总数&新增用户数
  getDevicePayBankStatistics: 'fr/getDevicePayBankStatistics', // 本行卡&非本行卡交易笔数
  offBankMerTicket: 'fr/offBankMerTicket', // 工具券下架处理
  getAllBankActList: 'fr/getAllBankActList', // 全行活动数据列表接口
  saveAllBankAct: 'fr/saveAllBankAct', // 保存全行活动信息
  updateAllBankActStatus: 'fr/updateAllBankActStatus', // 全行活动状态修改
  delAllBankAct: 'fr/delAllBankAct', // 删除全行活动信息
  getCooperateSignup: 'fr/getCooperateSignup', // 合作报名
  saveCooperateSignup: 'fr/saveCooperateSignup', // 合作报名
  getServiceCenter: 'fr/getServiceCenter', // 客服中心
  saveServiceCenter: 'fr/saveServiceCenter', // 客服中心
  getDefaultWeekHmfByBankId: 'fr/getDefaultWeekHmfByBankId', // 商家每周在驿站消耗惠民分默认值
  saveDefaultWeekHmf: 'fr/saveDefaultWeekHmf',// 保存商家应用规则每周用分值默认值
  udpateMerUpdateAgreeById: 'fr/udpateMerUpdateAgreeById',// 商家修改信息审核
  getMerUpdateAgreeByBankId: 'fr/getMerUpdateAgreeByBankId',// 商家修改信息查询
  getBankMerNoAgree: 'fr/getBankMerNoAgree',// 待审核
  getTodayNumAndMonney: 'fr/getTodayNumAndMonney',// 今日交易量、交易额及环比数据统计
  getOfflineTerminal: 'fr/getOfflineTerminal', // 离线终端列表
  getSingList: 'fr/getSingList', // 招牌展馆数据列表
  saveSign: 'fr/saveSign', // 保存招牌展馆信息
  singRemove: 'fr/singRemove', // 招牌展馆下架
  selectMerList: 'fr/selectMerList', // 显示商家数据列表
  singMerSave: 'fr/singMerSave', // 招牌展馆商家赋能
  getBaseGzzhfs: 'fr/getBaseGzzhfs', // 驿站分得分规则配置列表（商家分值明细传mer_id）
  getMerYZFByBankId: 'fr/getMerYZFByBankId', // 驿站分商家分值列表
  eidtZhfxsYZF: 'fr/eidtZhfxsYZF', // 驿站分规则编辑
  getBaseZhfxs: 'fr/getBaseZhfxs', // 驿站豆奖励系数配置查询
  saveZhfxsYZF: 'fr/saveZhfxsYZF', // 保存驿站分系数配置信息
  delZhfxsYZF: 'fr/delZhfxsYZF', // 删除驿站分系数配置信息
  baseZhfxsIsExists: 'fr/baseZhfxsIsExists', // 驿站豆奖励系数配置验证
  getBaseSound: 'fr/getBaseSound', // 声音配置列表查询
  editSoundById: 'fr/editSoundById', // 编辑声音配置信息
  getCityBankByBankId: 'fr/getCityBankByBankId', // 获取机构下行系列表
  getCardBinByBankId: 'fr/getCardBinByBankId', // 获取卡bin列表信息
  udpateCardBinStatusById: 'fr/udpateCardBinStatusById', // 设置卡bin启用和禁用
  delCardBinById: 'fr/delCardBinById', // 删除卡bin
  getSoundPathByCondition: 'fr/getSoundPathByCondition', // 设备端声音配置MAP查询
  udpateCenerIcoById: 'fr/udpateCenerIcoById', // 更新行系设备端图标
  getCenerIconByBankId: 'fr/getCenerIconByBankId', // 获取行系设备端图标
  getDeviceConfig: 'fr/getDeviceConfig', // 终端型号维护列表
  saveDeviceConfig: 'fr/saveDeviceConfig', // 终端型号维护保存
  delDeviceConfig: 'fr/delDeviceConfig', // 终端型号维护删除
  Merchant_reference_code_edit: 'fr/Merchant_reference_code_edit', // 修改商家推荐人
  getActiveUsers: 'fr/getActiveUsers', // 有效客户数据统计
  getViewCount: 'fr/getViewCount', // 浏览量数据统计
  getKeepUsers: 'fr/getKeepUsers', // 实际留存数据统计
  getRegisterUsers: 'fr/getRegisterUsers', // 用户注册数据统计
  getRegisterUsersByMonth: 'fr/getRegisterUsersByMonth', // 注册用户月度数据统计
  getRegisterUsersByYear: 'fr/getRegisterUsersByYear', // 注册用户年度数据统计
  getViewUsersByMonth: 'fr/getViewUsersByMonth', // 浏览量月度数据统计
  getViewUsersByYear: 'fr/getViewUsersByYear', // 浏览量年度数据统计
  getKeepUsersByMonth: 'fr/getKeepUsersByMonth', // 实际留存用户月度数据统计
  getKeepUsersByYear: 'fr/getKeepUsersByYear', // 实际留存用户年度数据统计
  getActiveUsersByMonth: 'fr/getActiveUsersByMonth', // 有效用户月度数据统计
  getActiveUsersByYear: 'fr/getActiveUsersByYear', // 有效用户年度数据统计
  getverify: 'fr/api/captcha/verify', // 验证码用户手动验证
  getgenerate: 'fr/api/captcha/generate', // 验证码请求
  isExistUser: 'fr/isExistUser', // 判断手机号账号是否存在
  postBankMerChangePassForPhoneVerificationCode: 'fr/wxapi/postBankMerChangePassForPhoneVerificationCode', // 银行或商家通过验证码方式修改登录密码
  postBankVerificationCode: 'fr/postBankVerificationCode', // 银行或商户通过验证码验证
  getPhoneVerificationCodeForActivity: 'fr/wxapi/getPhoneVerificationCodeForActivity', // 获取忘记密码中的验证码
  getActTicketListByCondition: 'fr/getActTicketListByCondition', // 推广计划列表
  getDeviceListByMtaId: 'fr/getDeviceListByMtaId', // 查看驿站列表
  getDeviceRefund: 'fr/getDeviceRefund', // 便利惠退款列表
  saveDeviceRefund: 'fr/saveDeviceRefund', // 便利惠退款功能新增
  delDeviceRefundById: 'fr/delDeviceRefundById', // 便利惠退款功能删除
  updateDeviceRefundById: 'fr/updateDeviceRefundById', // 便利惠退款办结
  getTradeNoByID: 'fr/getTradeNoByID', // 便利惠退款查询订单号
  getNewcustomerExclusiveAll: 'fr/getNewcustomerExclusiveAll', // 设备端展示新客专享数据
  getAllBankActAll: 'fr/getAllBankActAll' // 设备端展示全行活动数据
}
export default {
  name: 'serverurl',
  serverUrl: _serverUrl_,
}
</script>



// WEBPACK FOOTER //
// src/utils/UrlConst.vue